module.exports = __webpack_public_path__ + "img/bg_vw.e854c4ca.jpg";